import { Link } from "react-router-dom";
import hero1 from "../assets/images/hero/1.jpeg";
import hero2 from "../assets/images/hero/2.jpeg";
import hero3 from "../assets/images/hero/3.jpeg";
import hero4 from "../assets/images/hero/4.jpeg";
import hero8 from "../assets/images/hero/8.jpeg";
import hero9 from "../assets/images/hero/9.jpeg";
import hero10 from "../assets/images/hero/10.jpeg";
import { Fade } from "react-slideshow-image";

const Hero = () => {
  const fadeImages = [hero1, hero2, hero3, hero4, hero8, hero9, hero10];

  return (
    <section className="hero">
      <Fade
        autoplay={true}
        infinite={true}
        pauseOnHover={false}
        duration={5000}
        arrows={false}
      >
        <div className="hero__eachFade">
          <img src={fadeImages[0]} alt="Hero 1" />
        </div>
        <div className="hero__eachFade">
          <img src={fadeImages[4]} alt="Hero 5" />
        </div>
        <div className="hero__eachFade">
          <img src={fadeImages[2]} alt="Hero 3" />
        </div>
        <div className="hero__eachFade">
          <img src={fadeImages[3]} alt="Hero 4" />
        </div>
        <div className="hero__eachFade">
          <img src={fadeImages[1]} alt="Hero 2" />
        </div>
        <div className="hero__eachFade">
          <img src={fadeImages[5]} alt="Hero 6" />
        </div>
        <div className="hero__eachFade">
          <img src={fadeImages[6]} alt="Hero 7" />
        </div>
      </Fade>

      <div className="hero__main">
        {/* <h2></h2> */}
        <h1>
          Buy or book the repair of medical and surgical equipment and training
          of technical and caregiving officers.
        </h1>
        <p>
          Shop high quality medical surgical equipment and consumables. Schedule
          expert repair services, and or enroll in certified technical and
          caregiving programmes, trusted by biomedical engineers and special
          education experts.
        </p>

        <div className="hero__main__buttons">
          <Link to="/products">
            <button className="btnAlt">Shop Now</button>
          </Link>
          <Link to="/contact">
            <button className="btn">Contact Us</button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
